import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Button } from "react-bootstrap";
import { InfluencerCodeGenerator } from "../../helpers/Influencer.helper";
import { useSnackbar } from "react-simple-snackbar";
import { RegisterInfluencer } from "../../redux/actions/InfluencerAction";
import { useHistory } from "react-router-dom";

const RegisterModal = ({ openModal, closeModal }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [name, setName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [password, setPassword] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const register = (e) => {
    e.preventDefault();

    const influencerData = {
      name: name,
      phoneNumber: phoneNo,
      password: password,
      affiliatefee: 5,
      cuponDiscount: 5,
      couponCode: InfluencerCodeGenerator(name),
    };

    const onSuccess = (data) => {
      if (data.statusCode === 200 || data.statusCode === 201) {
        openSnackbar(data.message);
        history.push("/affiliate/login");
      } else {
        openSnackbar(data.message);
      }
    };

    const onError = (msg) => {
       if(msg === "Account Already exist"){
        history.push("/affiliate/login");
        openSnackbar(msg);
      }else{
      openSnackbar(msg);
      closeModal()
      }
    };

    dispatch(RegisterInfluencer(influencerData, onSuccess, onError));
    setName("");
    setPhoneNo("");
    setPassword("");
  };

  return (
    <>
      <Modal show={openModal} onHide={closeModal} onExited={() => closeModal()}>
        <Modal.Header closeButton>
          <Modal.Title >Join us 🙌</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-2 mb-3">
          <Form onSubmit={(e) => register(e)}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="number"
                value={phoneNo}
                onChange={(e) => setPhoneNo(e.target.value)}
                placeholder="Mobile Number"
                required
              />
              <Form.Text className="text-muted">
                Please enter valid mobile number .
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Name </Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Full Name"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
            </Form.Group>
            <Button
              className="affiliate-register-btn"
              type="submit"
              disabled={false}
            >
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RegisterModal;
